import { IconButton, Table, TableBody, TableCell, TableRow } from '@mui/material';
import * as React from 'react';
import { ReportePagosType } from '../../hooks/getDeuda';
import hash from 'object-hash';
import { lightDefaultColor } from '../../utils/constants';
import dayjs from 'dayjs';
import { Delete } from '@mui/icons-material';
import { useContext, useEffect, useState } from 'react';
import { UseDeletePago } from '../../hooks/addPAgo';
import { UserContext } from '../../contexts/userContext';


export function TablaPagos(props:{ pagos?:ReportePagosType[], id?: string, refresh?: () => void }) {
  const { pagos, id, refresh } = props;
  const { user } = useContext(UserContext);
  const [pagoToDelete, setPagoToDelete] = useState<{ id: string, fecha:string }>();
  const deletePago = UseDeletePago(pagoToDelete?.id, pagoToDelete?.fecha, user);

  useEffect(() => {
    if (deletePago.data && refresh) refresh();
  }, [deletePago.data]);

  if (!pagos) return null;

  return (
    <Table style={{ margin: 6 }}>
      <TableBody>
        <TableRow
          key={'encabezado-table-pagos'}
          style={{ borderStyle: 'solid', height: 20, backgroundColor: lightDefaultColor }}
        >
          <TableCell style={{ padding: '0px 16px' }}>Fecha</TableCell>
          <TableCell style={{ padding: '0px 16px' }}>Importe</TableCell>
          <TableCell style={{ padding: '0px 16px' }}>Medio</TableCell>
          <TableCell style={{ padding: '0px 16px' }}>Recibido Por</TableCell>
          <TableCell style={{ padding: '0px 16px' }}>Observaciones</TableCell>
          {id && refresh && <TableCell style={{ padding: '0px 16px' }} />}
        </TableRow>
        {pagos.map((pago:ReportePagosType) => (
          <TableRow
            key={hash(pago)}
            style={{ borderStyle: 'solid' }}
          >
            <TableCell style={{ padding: '0px 16px' }}>{dayjs(pago.fecha).format('DD/MM/YYYY')}</TableCell>
            <TableCell style={{ padding: '0px 16px' }}>{`$${pago.importe.toFixed(2)}`}</TableCell>
            <TableCell style={{ padding: '0px 16px' }}>{pago.transferencia ? 'Transferencia' : 'Efectivo'}</TableCell>
            <TableCell style={{ padding: '0px 16px' }}>{pago.recibidoPor}</TableCell>
            <TableCell style={{ padding: '0px 16px' }}>{pago.obs}</TableCell>
            {id && refresh && <TableCell style={{ padding: '0px 16px' }}>
              <IconButton onClick={() => {setPagoToDelete({ id, fecha:pago.fecha });}} size="small">
                <Delete color="error" fontSize="small" />
              </IconButton>
            </TableCell>}
          </TableRow>
        ))}
      </TableBody>
    </Table>);
}